/* Calculates business-day delivery estimates for Dynamic shipping product blocks. */
(() => {
  if (window.CustomDynamicShipping) {
    window.CustomDynamicShipping.init(document);
    return;
  }

  const selector = '[data-dynamic-shipping]';

  const addBusinessDays = (date, businessDays) => {
    const deliveryDate = new Date(date);
    let remainingDays = Math.max(0, Number(businessDays) || 0);

    while (remainingDays > 0) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
      const weekday = deliveryDate.getDay();
      if (weekday !== 0 && weekday !== 6) remainingDays -= 1;
    }

    return deliveryDate;
  };

  const isCurrentWeek = (date, today) => {
    const weekStart = new Date(today);
    const mondayOffset = (weekStart.getDay() + 6) % 7;
    weekStart.setHours(0, 0, 0, 0);
    weekStart.setDate(weekStart.getDate() - mondayOffset);

    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekEnd.getDate() + 6);
    weekEnd.setHours(23, 59, 59, 999);

    return date >= weekStart && date <= weekEnd;
  };

  const init = (scope = document) => {
    scope.querySelectorAll(selector).forEach((block) => {
      const dateTarget = block.querySelector('[data-dynamic-shipping-date]');
      if (!dateTarget) return;

      const today = new Date();
      const deliveryDate = addBusinessDays(today, block.dataset.leadTime);
      const formatOptions = isCurrentWeek(deliveryDate, today)
        ? {weekday: 'long'}
        : {weekday: 'long', day: 'numeric', month: 'long'};

      if (deliveryDate.getFullYear() !== today.getFullYear()) formatOptions.year = 'numeric';
      dateTarget.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en-ZA', formatOptions).format(deliveryDate);
    });
  };

  window.CustomDynamicShipping = {init};

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
